export default __webpack_public_path__ + "f5ba6ff59dcc862b1c91ca1bb23fcf55.png";